import React, { Fragment, ReactNode } from "react";
import { checkExceptions } from "../helpers/utilities";
import { Entitlement, User } from "../helpers/shared-interfaces";
import Unauthorized from "../pages/Unauthorized";

interface Props {
  children: ReactNode;
  entitlement: Entitlement;
  user: User;
  id: string;
}

export default (props: Props): JSX.Element => {
  const canViewEntity = checkExceptions({
    exceptions: props.entitlement.entityExceptions,
    user: props.user,
    id: props.id,
  });

  if (canViewEntity) {
    return <Fragment>{props.children}</Fragment>;
  } else {
    return <Unauthorized />;
  }
};
